var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"classes":"notification","group":"panel","position":"bottom right"}}),_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }